var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Close as CloseIcon } from '@mui/icons-material';
import { ModalConfirmacao } from './modal_confirmacao';
export function ModalConfirmarReprovar(props) {
    return (_jsx(ModalConfirmacao, __assign({}, props, { title: 'Confirmar Reprova\u00E7\u00E3o', titleColor: '#B91C1C', message: _jsxs(_Fragment, { children: ["Tem certeza que deseja reprovar esta justificativa? O reeducando poder\u00E1 enviar uma ", _jsx("strong", { children: "nova justificativa" }), " para este dia."] }), confirmText: 'CONFIRMAR RECUSA', submittingText: 'REPROVANDO...', confirmColor: '#B91C1C', confirmHoverColor: '#991B1B', icon: _jsx(CloseIcon, {}) })));
}
